export enum ImageGalleryLayout {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  TABLE = "table"
}
